import { IAction } from 'coral-utility';

export interface IFacetValue {
  key: string;
  doc_count: string;
}

export interface IFacet {
  values: IFacetValue[];
  selected: string[];
}

export interface ICategories {
  [x: string]: IFacet;
}
export interface IFacetState {
  categories: ICategories;
  __init: boolean;
}

export interface IDefaultFacet {
  label: string;
  value: string;
}

export enum Facets {
  MANUFACTURER = 'manufacturer',
  CLASS_OF_DETECTION_SYSTEM = 'classOfDetectionSystem.description',
  FILES = 'files.category',
}

export const defaultFacets: IDefaultFacet[] = [
  {
    label: 'Manufacturer',
    value: Facets.MANUFACTURER,
  },
  {
    label: 'Class of Detection System',
    value: Facets.CLASS_OF_DETECTION_SYSTEM,
  },
  {
    label: 'Files',
    value: Facets.FILES,
  },
  {
    label: 'RadNuc',
    value: 'radNuc',
  },
  {
    label: 'Chemical',
    value: 'chemical',
  },
  {
    label: 'Biological',
    value: 'biological',
  },
];
export const fields: string[] = defaultFacets.map(facet => facet.value);

const facetsActionTypes = {
  GET_DEFAULT_FACETS: 'GET_DEFAULT_FACETS',
  GET_DEFAULT_FACETS_SUCCESS: 'GET_DEFAULT_FACETS_SUCCESS',
  GET_DEFAULT_FACETS_FAILURE: 'GET_DEFAULT_FACETS_FAILURE',
  ADD_VALUE_TO_FACET: 'ADD_VALUE_TO_FACET',
  RESET_ALL_FILTERS: 'RESET_ALL_FILTERS',
  PROCESS_INIT_FACETS: 'PROCESS_INIT_FACETS',
  PROCESS_FACETS: 'PROCESS_FACETS',
};

export interface IDefaultFacetAction extends IAction {
  payload: {
    defaultFacets: IFacetState;
  };
}

export interface IAddFacetPayload {
  facet: string;
  value: string;
}

export interface IAddFacetAction extends IAction {
  payload: IAddFacetPayload;
}

export type IFacetActions = IAction | IDefaultFacetAction | IAddFacetAction;

export default facetsActionTypes;
